import { render } from "./NotificationMessenger.vue?vue&type=template&id=6c40e88c&scoped=true"
import script from "./NotificationMessenger.vue?vue&type=script&lang=js"
export * from "./NotificationMessenger.vue?vue&type=script&lang=js"

import "./NotificationMessenger.vue?vue&type=style&index=0&id=6c40e88c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c40e88c"]])

export default __exports__